// Logique pure des écrans des conseils (lot L5-B) : libellés et tons des états, texte du quorum et de la
// règle (toujours présentée comme paramètre de la collectivité, à confirmer par l'administration), actes
// proposés selon l'état de la session et les droits (le serveur refait tous les contrôles).
import { ETATS_DELIBERATION, ETATS_SESSION, texteFraction, type EtatDeliberation, type EtatQuorum, type EtatSession, type ParametresRegle } from '@cc/contrats';
import type { TonEtat } from '@cc/ui';
import type { ActeSession } from './api';

export const libelleSession = (e: EtatSession) => ETATS_SESSION[e];
export const libelleDeliberation = (e: EtatDeliberation) => ETATS_DELIBERATION[e];

export const TON_SESSION: Record<EtatSession, TonEtat> = {
  preparee: 'neutre', convoquee: 'attente', ouverte: 'signer', sans_quorum: 'retard', tenue: 'attente', pv_redige: 'attente', pv_valide: 'attente', transmise: 'attente', publiee: 'ok', archivee: 'neutre',
};
export const TON_DELIBERATION: Record<EtatDeliberation, TonEtat> = {
  inscrite: 'neutre', adoptee: 'ok', rejetee: 'retard', reportee: 'attente', transmise: 'attente', publiee: 'ok', executee: 'ok',
};

export function texteQuorum(q: EtatQuorum | null): string {
  if (!q) return 'Non calculé (séance non ouverte)';
  return `${q.compte} sur ${q.requis} requis (${q.presents} présent${q.presents > 1 ? 's' : ''}, ${q.representes} représenté${q.representes > 1 ? 's' : ''}, ${q.membres_en_exercice} membres en exercice) : ${q.atteint ? 'quorum atteint' : 'quorum non atteint'}`;
}

export function texteRegle(r: ParametresRegle): string[] {
  return [
    `Quorum : ${texteFraction(r.quorum)} des membres en exercice${r.quorum.procurations_comptent ? ', procurations comptées' : ', procurations non comptées'}`,
    `Majorité : ${texteFraction(r.majorite)} des ${r.majorite.base === 'suffrages_exprimes' ? 'suffrages exprimés' : r.majorite.base === 'presents_et_representes' ? 'membres présents et représentés' : 'membres en exercice'}${r.majorite.voix_preponderante_president ? ', voix du président prépondérante en cas de partage' : ''}`,
    `Vote : ${r.vote.mode === 'nominatif' ? 'nominatif' : 'à main levée (totaux seulement)'}`,
    `Procurations : ${r.procurations.autorisees ? `autorisées, ${r.procurations.max_par_mandataire} par mandataire au plus` : 'non autorisées'}`,
    `Convocation : ${r.convocation.delai_jours} jour(s) avant la séance au plus tard`,
  ];
}

export interface DroitsConseils {
  modifier: boolean;
  valider: boolean;
  signer: boolean;
}

/** Actes simples proposés pour une session selon son état et les droits du lecteur. */
export function actesSession(etat: EtatSession, d: DroitsConseils, quorumAtteint: boolean | null): ActeSession[] {
  const a: ActeSession[] = [];
  if (etat === 'preparee' && d.modifier) a.push('convocation');
  if (etat === 'convoquee' && d.modifier) a.push('ouverture');
  if (etat === 'ouverte' && d.modifier && quorumAtteint) a.push('cloture');
  if (etat === 'tenue' && d.modifier) a.push('pv');
  if (etat === 'transmise' && d.signer) a.push('publication');
  if ((etat === 'publiee' || etat === 'sans_quorum') && d.modifier) a.push('archivage');
  return a;
}
